import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchUpdateApiKeySettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingUpdateAPIKeySettingsAttempt', handleUpdateApiKeySettings, api);
}

function* handleUpdateApiKeySettings(api: SettingGateway) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;

    if (!authToken && authToken === undefined) {
        yield put(combinedActions.settingUpdateAPIKeySettingsFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.updateApiKeySettings], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingUpdateAPIKeySettingsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success('API Key Generated Successfully!');
        yield put(combinedActions.settingSetRegenerateAPIKeyModalIsOpen(false));
        yield put(combinedActions.settingUpdateAPIKeySettingsSuccess());
        yield put(combinedActions.settingGetAPIKeySettingsAttempt()); // get new api key
        yield put(combinedActions.settingGetAPIKeyHistoryListingAtempt());// get new api key history listing
    }
}
